import { render, staticRenderFns } from "./FollowupDetails.vue?vue&type=template&id=6681d43b&"
import script from "./FollowupDetails.vue?vue&type=script&lang=js&"
export * from "./FollowupDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports